import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { BASE_URL, URL } from "./constants";

export const api = createApi({
  reducerPath: "api",
  baseQuery: fetchBaseQuery({
    baseUrl: BASE_URL,
    prepareHeaders: async (headers) => {
      headers.set("Authorization", "Bearer " + localStorage.getItem("token"));
      // headers.set("Content-Type", "multipart/form-data");
      // headers.set("Content-Type", "application/json");
      // headers.set("Accept", "multipart/form-data");
    },
  }),
  refetchOnMountOrArgChange: true,
  tagTypes: ["profileData", "menuList", "tableList"],
  endpoints: (builder) => ({
    // SHOW CATEGORIES
    showCategories: builder.query({
      query: () => URL.SHOW_CATEGORIES,
    }),

    // GET TABLES
    getTables: builder.query({
      query: () => URL.GET_TABLE,
    }),

    // PLACE ORDER
    placeOrder: builder.mutation({
      query: (payload) => ({
        url: URL.PLACE_ORDER,
        method: "POST",
        body: payload,
        headers: {
          "Content-Type": "application/x-www-form-urlencoded",
        },
      }),
    }),

    // LOGIN
    login: builder.mutation({
      query: (payload) => ({
        url: URL.LOGIN,
        method: "POST",
        body: payload,
        headers: {
          // data: console.log(payload),
          // "Content-Type": "application/x-www-form-urlencoded",
        },
      }),
    }),

    // CATEGORIES (ALL DATA)
    categories: builder.query({
      query: () => URL.CATEGORIES,
      providesTags: ["menuList"],
    }),

    // CRAETE CATEGORY
    createCategory: builder.mutation({
      query: (payload) => ({
        url: URL.CREATE_CATEGORY,
        method: "POST",
        body: payload,
      }),
    }),

    // CREATE ITEM
    createItem: builder.mutation({
      query: (payload) => ({
        url: URL.CREATE_ITEM,
        method: "POST",
        body: payload,
      }),
    }),

    // EDIT ITEM
    editItem: builder.mutation({
      query: (payload) => ({
        url: URL.EDIT_ITEM,
        method: "POST",
        body: payload,
      }),
    }),

    // STATUS CHANGE
    statusChange: builder.mutation({
      query: (payload) => ({
        url: URL.STATUS_CHANGE,
        method: "POST",
        body: payload,
      }),
      invalidatesTags: ["menuList"],
    }),

    // DELETE ITEM
    deleteItem: builder.mutation({
      query: (payload) => ({
        url: URL.DELETE_ITEM,
        method: "POST",
        body: payload,
      }),
      invalidatesTags: ["menuList"],
    }),

    // CREATE TABLE
    createTable: builder.mutation({
      query: (payload) => ({
        url: URL.CREATE_TABLE,
        method: "POST",
        body: payload,
      }),
    }),

    // EDIT TABLE
    editTable: builder.mutation({
      query: ({ id, payload }) => ({
        url: URL.EDIT_TABLE + id,
        method: "POST",
        body: payload,
      }),
    }),

    // GET TABLES
    getTablesAdmin: builder.query({
      query: () => URL.GET_TABLES,
    }),

    // TABLE STATUS CHANGE
    tableStatusChange: builder.query({
      query: (id) => URL.TABLE_STATUS_CHANGE + id,
    }),

    // ORDER LIST
    orderList: builder.query({
      query: () => URL.ORDER_LIST,
    }),

    // ORDER DETAILS
    orderDetails: builder.query({
      query: (id) => URL.ORDER_DETAILS + id,
    }),

    // LOGOUT
    logout: builder.mutation({
      query: () => ({
        url: URL.LOGOUT,
        method: "POST",
      }),
    }),

    // EDIT CATEGORY
    editCategory: builder.mutation({
      query: (payload) => ({
        url: URL.EDIT_CATEGORY,
        method: "POST",
        body: payload,
      }),
    }),
  }),
});

export const {
  useShowCategoriesQuery,
  useGetTablesQuery,
  usePlaceOrderMutation,
  useLoginMutation,
  useCategoriesQuery,
  useCreateCategoryMutation,
  useCreateItemMutation,
  useEditItemMutation,
  useStatusChangeMutation,
  useDeleteItemMutation,
  useCreateTableMutation,
  useEditTableMutation,
  useGetTablesAdminQuery,
  useLazyTableStatusChangeQuery,
  useOrderListQuery,
  useLazyOrderDetailsQuery,
  useLogoutMutation,
  useEditCategoryMutation,
} = api;
